import { DELETE_NOTIFICATION } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_NOTIFICATION.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_NOTIFICATION.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case DELETE_NOTIFICATION  .FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
